// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cold_list":"cold_list-HHObpRT4","cold_a":"cold_a-9s8hF2u0"};